import { useCallback, useEffect, useState } from "react";

interface ModalWrapperProps {
	children: React.ReactNode;
	size?: string;                              // string으로 유연하게 설정
	width?: number;                             // width는 선택적 (기본값 70)
	overlay?: boolean;
	onOverlayClick?: () => void;
	onEscKeyDown?: () => void;
}

const ModalWrapper = ({ 
	children, 
	size = 'lg', 
	width = 70, 
	overlay = false, 
	onOverlayClick, 
	onEscKeyDown 
}: ModalWrapperProps) => {
	
	// size에 따른 height 자동 설정
	const getHeightBySize = (size: string) => {
		const heightMap: Record<string, number> = {
			xs: 30,
			sm: 50,
			md: 70,
			lg: 80,
			xl: 90,
			half: 50,    // 기존 값 추가
			mmd: 45      // 기존 값 추가
		};
		return heightMap[size] || 50;
	};

	const height = getHeightBySize(size);

	const handleEscKeyDown = useCallback((e: KeyboardEvent) => {
		// event.ctrlKey가 true이고 (Ctrl 키가 눌린 상태)
		// event.key가 'Escape'이면 (Escape 키가 눌렸을 때)
		if (e.key === 'Escape' && onEscKeyDown) {
			onEscKeyDown()
		}
	}, []); // useCallback으로 함수를 메모이제이션합니다.

	
	useEffect(() => {
		// 이벤트 리스너 추가
		window.addEventListener('keydown', handleEscKeyDown);
		// cleanup 함수에서 리스너 제거
		return () => {
			window.removeEventListener('keydown', handleEscKeyDown);
		};
	}, [])


	return (
		<div className={`fixed inset-0 flex justify-center items-center z-10`}>
			{overlay && <div className="w-full h-full absolute bg-black opacity-[0]" onClick={onOverlayClick} />}
			<div 
				className="flex flex-col overflow-auto bg-white shadow-xl rounded-[8px] z-10 border-2 border-black"
				style={{ 
					width: `${width}%`,
					height: `${height}%`,
					maxHeight: `${height}%`
				}}
			>
				{children}
			</div>
		</div>
	);
};

export default ModalWrapper;